import {inject} from "@angular/core";
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {WaypointService} from "@services";
import {Waypoint} from "@model";

export const WaypointListResolver: ResolveFn<Observable<Waypoint[]> | Waypoint[]> =
  (route: ActivatedRouteSnapshot,
   _: RouterStateSnapshot,
   waypointService: WaypointService = inject(WaypointService)): Observable<Waypoint[]> | Waypoint[] => {
    if (+route.queryParams['raceId']) {
      return waypointService.findWaypoints(+route.queryParams['raceId']);
    } else {
      return [];
    }
  }
